import { useMemo } from 'react';

import { type PaymentMethodCard } from '@sg/graphql-schema';

import { usePaymentMethodsQuery } from './graphql/PaymentMethods.generated';

export const usePaymentMethods = () => {
  const [{ data, fetching: isLoadingPaymentMethods }] = usePaymentMethodsQuery({
    requestPolicy: 'network-only',
  });

  const paymentMethods = useMemo(
    () => data?.paymentMethodCards ?? [],
    [data?.paymentMethodCards],
  ) as PaymentMethodCard[];

  return {
    paymentMethods,
    isLoadingPaymentMethods,
  };
};
